import axios, { AxiosRequestConfig } from 'axios'

const apiClient = axios.create({
    baseURL: 'handlers/appbuilder.ashx',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
})

export default {
    getApplicationIndustries(id: number, tags: string) {
        const data = new FormData();
        data.append('type', 'getAppsByCategory');
        data.append('categoryId', id.toString());
        data.append('tags', tags);

        const config: AxiosRequestConfig = {
            method: 'post',
            data: data
        };

        return apiClient(config);
    },

    getFeaturedApplicationIndustries() {
        const data = new FormData();
        data.append('type', 'getFeaturedIndustries');

        const config: AxiosRequestConfig = {
            method: 'post',
            data: data
        };

        return apiClient(config);
    },
}
